module.exports = __webpack_public_path__ + "static/assets/c02ce8b6f8612d2e107aebf97fef84a8.png";